import { FormikProps } from 'formik'
import { debounce } from '@src/helpers/helperFunctions'
import { setNumberTo2DecimalsOnly } from '@src/helpers/numberHelpers'
import { updateDays } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils'
import { TDay } from '@src/ui/components/Admin/Shifts/ShiftEditDuplicate/utils/types'
import { INewEditModalFormValues } from '../../new-edit-modal.form'

/**
 * A function that performs pay value update for each gig day
 * @param payValue
 * @param multidayDays
 * @param toHireDays
 * @param setFieldValue
 */
const updatePayValueToGigDays = (
  payValue: string,
  multidayDays: TDay[],
  toHireDays: TDay[],
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean | undefined) => void
) => {
  const days = updateDays(multidayDays, {
    pay_value: payValue,
  })
  setFieldValue('days', days)
}

const debouncedUpdatePayValueToGigDays = debounce(updatePayValueToGigDays, 300)

export const handlePayRateChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<INewEditModalFormValues>
) => {
  const { setFieldValue, values } = formik

  const payValue = setNumberTo2DecimalsOnly(e.target.value)

  setFieldValue('pay_value', payValue)
  debouncedUpdatePayValueToGigDays(payValue, values.days, [], setFieldValue)
}

// Handle days change
export const handlePositionsChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  formik: FormikProps<INewEditModalFormValues>
) => {
  const { setFieldValue, values } = formik
  const rawValue = e.target.value
  if (rawValue === '') {
    setFieldValue('positions', '')
    return
  }
  let positions = Number(setNumberTo2DecimalsOnly(rawValue))
  if (positions < 0) positions = 0
  setFieldValue('positions', positions)
}
